import { ListSortDirection, Sort } from "../../models/api/sort";
import {
  EmployeeBankAccountDTO,
  EmployeeBankAccountsFilter,
  EmployeeBankAccountSTO,
} from "../../models/employee-bank-accounts";
import { BaseApiService } from "../base/base-api.service";

export class EmployeesBankAccountsApiService extends BaseApiService<EmployeeBankAccountDTO, EmployeeBankAccountSTO> {
  constructor() {
    super({
      servicePath: "/EmployeesBankAccounts",
      loadItemsPath: "/GetEmployeesBankAccounts",
      saveItemsPath: "/SaveEmployeesBankAccounts",
    });
    this.defaultSort = [
      {
        name: "employee.firstName",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "employee.lastName",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "iban",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadCurrentUserEmployeesBankAccounts = async (
  employeeId: string,
  forManager: boolean,
  signal?: AbortSignal
) => {
  const apiService = new EmployeesBankAccountsApiService();
  if (!forManager) {
    apiService.useLoadItemsPath("/GetCurrentUserEmployeesBankAccounts");
  }

  const response = await apiService.loadItems(
    !forManager
      ? ({ employeeId } as EmployeeBankAccountsFilter)
      : ({ employeeIds: [employeeId] } as EmployeeBankAccountsFilter),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  return response;
};
